import { Button } from '@/components/ui/button';
import { ApiError, api } from '@/lib/api';
import { useMutation } from '@tanstack/react-query';
import { CheckCircle2 } from 'lucide-react';
import { useState } from 'react';

interface Props {
  onAdvance: () => void;
}

export function StepFinish({ onAdvance }: Props) {
  const [serverError, setServerError] = useState<string | null>(null);
  const mutation = useMutation({
    mutationFn: () => api.onboardingFinish(),
    onSuccess: () => onAdvance(),
    onError: (err: unknown) => {
      setServerError(err instanceof ApiError ? err.message : '알 수 없는 오류');
    },
  });

  return (
    <div className="text-center py-6">
      <div className="mx-auto size-14 rounded-full bg-accent/10 grid place-items-center mb-4">
        <CheckCircle2 className="size-7 text-accent" />
      </div>
      <h2 className="text-lg font-semibold">모든 단계가 준비됐어요</h2>
      <p className="mt-2 text-sm text-foreground-muted">
        버튼을 누르면 부트스트랩이 잠기고 정상 모드로 전환됩니다.
        <br />
        이후에는 로그인 화면으로 이동해요.
      </p>

      {serverError ? (
        <div className="mt-4 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
          {serverError}
        </div>
      ) : null}

      <Button
        className="mt-6"
        size="lg"
        onClick={() => mutation.mutate()}
        disabled={mutation.isPending}
      >
        {mutation.isPending ? '마무리 중…' : '설정 마치기'}
      </Button>
    </div>
  );
}
